@if (isVisible) {
  <span class="override-tag" [class.override-tag--green]="badgeClass === 'override-tag--green'" [class.override-tag--orange]="badgeClass === 'override-tag--orange'" [class.override-tag--red]="badgeClass === 'override-tag--red'">{{ label }}</span>
}
